import React from 'react'
import {
  Box,
  Card,
  Center,
  Link,
  Heading,
  Text,
  Container,
  Flex,
  Image,
  VStack,
  HStack,
  useColorModeValue,
  useBreakpointValue,
} from '@chakra-ui/react'
import { BsStarFill, BsStar } from 'react-icons/bs'

import { ContainerBase } from '@/components/containers/ContainerBase'
import Carousel from '@/components/carousel/Carousel'

type Props = {
  title: string
  subtitle?: string
  reviews: Array<{
    fullName: string
    review: string
    activeStars: number
    totalStars: number
  }>
}

export const CustomerReviews = ({ title, subtitle, reviews }: Props) => {
  const reviewsBorderColor = useColorModeValue(
    'blackAlpha.500',
    'whiteAlpha.500'
  )
  const reviewsSecondaryColor = useColorModeValue(
    'blackAlpha.800',
    'whiteAlpha.800'
  )

  const reviewItemWidth = useBreakpointValue({
    base: 1,
    md: 2,
    lg: 3,
    '2xl': 4,
  })

  return (
    <ContainerBase maxWidth={{ xxl: '1600px' }} px={0} mx={0} py={0}>
      <Center flexDirection="column" px={5}>
        <Heading
          variant="spaceGrotesk"
          as="h2"
          fontSize="32px"
          textAlign="center"
          fontWeight={300}
          mb={subtitle ? 6 : { base: 9, lg: 12 }}
        >
          {title}
        </Heading>
        {subtitle && <Text mb={6}>{subtitle}</Text>}
      </Center>
      <Box width="100%" px={{ base: '', md: '', xl: '53px' }}>
        {reviewItemWidth && (
          <Carousel
            gap={32}
            containerHeight={{ base: '240px', md: '335px' }}
            containerWidth={reviewItemWidth}
            alwaysFullWidthContainer
          >
            {reviews.map((review, index) => (
              <Flex
                key={index}
                border={'1px'}
                borderColor={reviewsBorderColor}
                flexDirection="column"
                overflow="hidden"
                rounded={5}
                flex={1}
                p={5}
              >
                <VStack>
                  <Text
                    fontSize={{ base: '18px', md: '24px' }}
                    lineHeight={{ base: '24px', md: '29px' }}
                    textAlign="left"
                    w="full"
                    mb={2}
                    fontWeight={'semibold'}
                  >
                    {review.fullName}
                  </Text>
                  <Text
                    w="full"
                    color={reviewsSecondaryColor}
                    fontSize={{ base: '14px', md: '18px' }}
                    lineHeight={{ base: '20px', md: '22px' }}
                  >
                    {review.review}
                  </Text>
                </VStack>
                <HStack
                  spacing={2}
                  w="full"
                  justify={'flex-end'}
                  mt={{ base: '15px', md: '20px' }}
                >
                  {[...new Array(review.totalStars)].map((arr, index) => {
                    return index < review.activeStars ? (
                      <BsStarFill color="#ECC94B" key={`stars_${index}`} />
                    ) : (
                      <BsStar color="#ECC94B" key={`stars_${index}`} />
                    )
                  })}
                </HStack>
              </Flex>
            ))}
          </Carousel>
        )}
      </Box>
    </ContainerBase>
  )
}
